import React, { useState } from "react"
import { anchormeBandNada, maskMentions, unmaskMentions } from "../../util/strings"
import "./FreeTextFormat.scss"

/**
 * Strips links from text:
 * - Removes HTML anchor tags (<a href="...">text</a> -> text)
 * - Removes markdown links ([text](url) -> text)
 * - Removes plain URLs
 * Preserves newlines while cleaning up other whitespace
 */
function stripLinks(text) {
  if (!text) return text

  // Remove HTML anchor tags, keeping the text content
  let cleaned = text.replace(/<a\s+[^>]*>([^<]*)<\/a>/gi, "$1")

  // Remove markdown-style links [text](url) -> text
  cleaned = cleaned.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")

  // Remove plain URLs (http://, https://, www.)
  cleaned = cleaned.replace(/\b(https?:\/\/|www\.)[^\s]+/gi, "")

  // Clean up extra whitespace but preserve newlines
  // Replace multiple spaces/tabs with single space, but keep newlines
  cleaned = cleaned.replace(/[ \t]+/g, " ")
  // Clean up spaces around newlines
  cleaned = cleaned.replace(/ +(\n)/g, "$1")
  cleaned = cleaned.replace(/(\n) +/g, "$1")
  // Trim start and end but preserve internal newlines
  cleaned = cleaned.trim()

  return cleaned
}

export const FreeTextFormat = ({
  text,
  expandable = true,
  expanded = false,
  linkify = false,
  stripLinks: shouldStripLinks = false,
}) => {
  const [expandText, setExpandText] = useState(expanded)

  // Mask @[@handle](path) mention markup before stripLinks runs, since its
  // generic markdown-link stripping doesn't know about mentions and would
  // otherwise mangle them (dropping the link and leaving a stray leading
  // "@"). Unmask back into the real link HTML afterward so a mention always
  // renders as a working "@handle" link, regardless of the linkify/
  // stripLinks combination the caller picked.
  const [maskedText, mentionPlaceholders] = maskMentions(text)
  const strippedText = shouldStripLinks ? stripLinks(maskedText) : maskedText
  const processedText = unmaskMentions(strippedText, mentionPlaceholders)

  return (
    <>
      {expandText ? (
        <>
          <div
            className="free-text-format"
            dangerouslySetInnerHTML={{
              __html: linkify
                ? anchormeBandNada(processedText.replace(/\n/g, "<br/>"))
                : processedText.replace(/\n/g, "<br/>"),
            }}
          ></div>
          {expandable && (
            <span
              className="cursor-pointer italic text-blue-600"
              onClick={(e) => setExpandText(false)}
            >
              less
            </span>
          )}
        </>
      ) : (
        <>
          <div
            style={{
              maxHeight: "9em",
              overflow: "hidden",
              textOverflow: "elipsis",
            }}
            dangerouslySetInnerHTML={{
              __html: linkify
                ? anchormeBandNada(processedText, false)
                : processedText,
            }}
          ></div>
          {expandable && (
            <span
              className="cursor-pointer italic text-blue-600"
              onClick={(e) => setExpandText(true)}
            >
              more
            </span>
          )}
        </>
      )}
    </>
  )
}

export default FreeTextFormat
